import { useCallback } from 'react';
import { AIRDemoPanel } from '@frontend/ai-receptionist-sales-demo';
import { CallInsightPanel } from '@frontend/call-insight-panel';
import { MessageInsightsPanel } from '@frontend/message-insights-panel';
import { GlobalPanelEntry, useGlobalPanel } from '@frontend/panel-engine';
import { openSchedulePulse, openSchedulePulseRequest, SchedulePulseTab } from '@frontend/schedule';
import { useAppScopeStore } from '@frontend/scope';

export { VoicemailDetailsGlobalPanel } from '@frontend/calls-v2';

export const AIRSalesDemoGlobalPanel = () => {
  const { close } = useGlobalPanel('air-sales-demo');
  const { selectedLocationIds } = useAppScopeStore();
  const locationId = selectedLocationIds[0];

  const handleViewAppointmentRequest = useCallback(
    (requestId: string) => {
      if (requestId) {
        openSchedulePulseRequest(locationId, requestId);
      } else {
        openSchedulePulse(SchedulePulseTab.AppointmentRequests);
      }
    },
    [locationId]
  );

  return (
    <GlobalPanelEntry id='air-sales-demo' width='medium'>
      <AIRDemoPanel onClose={close} onViewAppointmentRequest={handleViewAppointmentRequest} />
    </GlobalPanelEntry>
  );
};

/**
 * ## GLOBAL PANEL REGISTRATION
 *
 * This file is used to register global panels that can be opened from anywhere in the app.
 * Simply export your global panel component here and it will be registered automatically.
 */

export const CallTakeawayGlobalPanel = () => (
  <GlobalPanelEntry id='call-insight' width='medium'>
    <CallInsightPanel />
  </GlobalPanelEntry>
);
export const MessageInsightsGlobalPanel = () => (
  <GlobalPanelEntry id='message-insights' width='medium'>
    <MessageInsightsPanel />
  </GlobalPanelEntry>
);
